export class OnlyShowSelectedInTableValueConverter {
	toView(value: any[], onlyShowSelected: boolean) {
		if (!onlyShowSelected) {
			return value;
		}
		return value.filter((item) => item.isSelected);
	}}
